<template>
    <content-wrapper>
        <Content class="mt-3">
            <b-card header-bg-variant="dark">
                <template #header>
                    <b-row class="align-items-center justify-content-between text-nowrap">
                        <b-col>
                            <h6 class="mb-0">Retry Set Permit</h6>
                        </b-col>
                        <b-col md="2"></b-col>
                        <b-col>
                            <h6 class="mb-0">Count <span>{{ retryCount }}</span></h6>
                        </b-col>
                        <b-col>
                            <h6 class="mb-0">Done <span>{{ retryDone }}</span></h6>
                        </b-col>
                    </b-row>
                </template>

                <b-row class="mb-3 align-items-stretch">
                    <!-- Dropdown -->
                    <b-col cols="12" md="4" class="mb-2 mb-md-0 pr-md-1">
                        <b-form-select
                        v-model="searchType"
                        :options="searchOptions"
                        ></b-form-select>
                    </b-col>

                    <!-- Input + Button Search -->
                    <b-col cols="12" md="6" class="mb-2 mb-md-0 px-md-1">
                        <b-input-group>
                        <b-form-input
                            placeholder="Keywords"
                            v-model="searchKeywords"
                            @keyup.enter="handleSearch"
                        />
                        <b-input-group-append>
                            <b-button variant="primary" @click="handleSearch">
                            <b-icon icon="search" />
                            </b-button>
                        </b-input-group-append>
                        </b-input-group>
                    </b-col>

                    <!-- Reset -->
                    <b-col cols="12" md="2" class="pl-md-1">
                        <b-button class="w-100 text-nowrap" variant="outline-secondary" @click="resetSearch">
                        Refresh
                        </b-button>
                    </b-col>
                </b-row>

                <!-- PERMIT TABLE  -->
                <b-table ref="table"
                        id="table"
                        :per-page="pagination.per_page"
                        :current-page="pagination.current_page"
                        :items="loadPage"
                        :fields="columns"
                        :busy.sync="isLoading"
                        striped
                        borderless
                        outlined
                        hover
                        show-empty
                        empty-text="No records found..."
                        stacked="sm"
                        class="mb-3"
                >
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                        <b-spinner label="Loading..." type="grow"></b-spinner>
                        </div>
                    </template>

                    <template #cell(no)="data">
                        {{ (pagination.current_page - 1) * pagination.per_page + data.index + 1 }}
                    </template>

                    <template #cell(kd_transaksi)="data">
                        <span v-if="data.item.kd_transaksi == 1">
                            <div class="badge badge-sm badge-primary">Export</div>
                        </span>
                        <span v-else-if="data.item.kd_transaksi == 2">
                                <div class="badge badge-sm badge-danger">Import</div>
                        </span>
                    </template>

                    <template #cell(actions)="data">
                        <b-button squared variant="info" class="flex-grow-1 btn-sm text-nowrap" @click="retry(data.item)">
                            <b-spinner v-if="isLoading" small></b-spinner>
                            &nbsp;Retry&nbsp;
                        </b-button>
                    </template>

                </b-table>

                <!-- pagination -->
                <div class="d-flex justify-content-center">
                    <laravel-pagination
                        :pagination="pagination"
                        @change="changePage"
                        />
                </div>

            </b-card>
        </Content>
    </content-wrapper>
</template>

<script>
import {
  BIcon,
  BInputGroup, BFormInput,
} from "bootstrap-vue";
import {listSetPermit, retrySetPermit} from "@/services/mware";
import LaravelPagination from "@/components/LaravelPagination";

export default {
    name: 'RetrySetPermit',
    components: {
        LaravelPagination,
        BIcon, BInputGroup, BFormInput
    },
    data() {
        return {
            retryCount: '-',
            retryDone: '-',
            searchType: 'no_cont',
            searchOptions: [
                { value: 'no_cont', text: 'Container' },
                { value: 'lic_plate', text: 'License Plate' },
                { value: 'bsims_id', text: 'ID Transaksi' },
            ],
            searchKeywords: '',
            pagination: { // based on Laravel pagination response
                current_page: 1,
                first_page_url: '',
                from: 1,
                last_page: 1,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 13,
                prev_page_url: '',
                to: 10,
                total: 10,
            },
            filters: {},
            columns: [
                {
                    key: 'no',
                    label: 'No',
                },
                {
                    key: 'bsims_id',
                    label: 'BISMS ID',
                },
                {
                    key: 'no_cont',
                    label: 'Container',
                },
                {
                    key: 'lic_plate',
                    label: 'No. Pol',
                },
                {
                    key: 'event_id',
                    label: 'Event',
                },
                {
                    key: 'kd_transaksi',
                    label: 'Direction',
                },
                {
                    key: 'bsims_posted',
                    label: 'BISMS Posted',
                    formatter: x => typeof x === 'string' ? x.replace(/\+.*/, '') : '-',
                },
                {
                    key: 'actions',
                    label: 'Actions',
                }
            ],
            isLoading: false,
        }
    },
    methods: {
        async loadPage() {
            try{
                this.isLoading = true;
                const payload = {
                    ...this.pagination,
                    ...this.filters,
                };
                // const list_retry = JSON.parse(await listRetry(payload)).event_ids;
                const list_retry = JSON.parse(await listSetPermit(payload));
                console.log('list_retry',list_retry);

                this.retryCount = new Intl.NumberFormat('id-ID').format(list_retry.data.total || 0);
                this.retryDone = new Intl.NumberFormat('id-ID').format(list_retry.retried || 0);
                this.pagination = {
                    current_page: list_retry.data.current_page,
                    first_page_url: list_retry.data.first_page_url,
                    from: list_retry.data.from,
                    last_page: list_retry.data.last_page,
                    last_page_url: list_retry.data.last_page_url,
                    links: list_retry.data.links,
                    next_page_url: list_retry.data.next_page_url,
                    path: list_retry.data.path,
                    per_page: list_retry.data.per_page,
                    prev_page_url: list_retry.data.prev_page_url,
                    to: list_retry.data.to,
                    total: list_retry.data.total,
                }

                return list_retry.data.data || [];
            } catch (error) {
                console.error('Error loading data:', error);
                return [];
            }
        },
        handleSearch() {
            console.log('Searching for:', this.searchType, this.searchKeywords, this.pagination.current_page);
            this.pagination.current_page = 1; // reset
            this.filters = {
                [this.searchType]: this.searchKeywords,
            };
            this.$refs.table.refresh();
        },
        resetSearch() {
            this.searchType = 'no_cont';
            this.searchKeywords = '';
            this.filters = {};
            this.pagination.current_page = 1; // reset
            this.$refs.table.refresh();
        },
        changePage(page) {
            this.pagination.current_page = page;
            this.$refs.table.refresh();
        },
        async retry(item) {
            // Implement retry logic here
            // console.log('Retrying for item:', item);
            const response = JSON.parse(await retrySetPermit(item));
            console.log('RetryExec', item, 'Response:', response);
            if(response.status === 'processing') {
                this.$bvToast.toast(`Retry successful for BISMS ID: ${item.bsims_id}`, {
                    title: 'Success',
                    variant: 'success',
                    solid: true
                });
                await new Promise(resolve => setTimeout(resolve, 3000));
                this.$refs.table?.refresh();
            } else {
                this.$bvToast.toast(`Retry failed for BISMS ID: ${item.bsims_id}. Error: ${response.message || 'Unknown error'}`, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            }

        },
    }
}
</script>